import React from 'react';
import PropTypes from 'prop-types';
import FadeIn from 'react-fade-in';

import { CONTENT_PROPS } from '../shared/constants';

//#region //// COMPONENTS ///
import ContentCard from '../ContentCard';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
//#endregion

//#region ///// DUCKS /////
import './styles.scss';
import { IMAGE_MODE } from '../../constants/imageMode';
import ContentGridFilter from './components/ContentGridFilter';
//#endregion

function ContentGrid ({
  contentCardProps = {},
  contentCollection = [],
  imageMode = IMAGE_MODE.THUMB,
  isLoading,
  selectedContentHandler = (c) => alert(`Selected Content: ${c.title}`),
  countItem=8,
  title,
  contentNoImageProps,
  networks,
  channels,
  enableFilters = false,
  orderTypeSelected = null,
  selectFilterHandler=()=> console.log("gallery_wall"),
  orderTypeArray = [],
  textMode,
  customClassName='',
  noItemsDescription= ''
}) {
  if(contentCollection.length === 0 && isLoading) contentCollection.push(...new Array(countItem))
  return (
    <section className={`tbxContentGrid`}>
      <FadeIn  className={enableFilters ? customClassName : ''}>
        <div className={`tbxContentGrid__heading_container`}>
          { title && <h2 className="tbxContentGrid__heading">{title}</h2> }
          { enableFilters && 
            <ContentGridFilter 
              orderTypeSelected = {orderTypeSelected}
              selectFilterHandler = {selectFilterHandler}
              orderTypeArray = {orderTypeArray}
          />}
        </div>
        { noItemsDescription && <div className='noItemsDescription'>{noItemsDescription}</div> }
        <div className={`tbxContentGrid__gallery-${imageMode}`}>
        {
          contentCollection.map((content,index) => {
            return (
              <div
                className="tbxContentGrid__content"
                key={`tbx-contentgrid-item-${content?.id || index}`}
                onClick={!isLoading && (() => selectedContentHandler(content))}
              >
                <ContentCard
                  {...contentCardProps}
                  content={content}
                  imageMode={imageMode}
                  isLoading={isLoading}
                  contentNoImageProps={contentNoImageProps}
                  textMode = {textMode}
                  networks = {networks}
                  channels = {channels}
                />
              </div>
            );
          })
        }
        </div>
      </FadeIn>
    </section>
  );
}

ContentGrid.propTypes = {
  contentCardProps: PropTypes.shape({
    prefixNetworkText: PropTypes.string
  }),
  contentCollection: PropTypes.arrayOf(PropTypes.shape(CONTENT_PROPS)),
  imageMode: PropTypes.oneOf([IMAGE_MODE.POSTER,IMAGE_MODE.SIMPLE_LARGE,IMAGE_MODE.THUMB]),
  isLoading: PropTypes.bool,
  selectedContentHandler: PropTypes.func,
  title: PropTypes.string,
  contentNoImageProps: PropTypes.object,
  countItem: PropTypes.number,
  networks: PropTypes.array,
  channels: PropTypes.array,
  enableFilters: PropTypes.bool,
  orderTypeSelected: PropTypes.string,
  selectFilterHandler: PropTypes.func,
  orderTypeArray: PropTypes.array,
  noItemsDescription: PropTypes.string

};

export default WithErrorBoundary(React.memo(ContentGrid));
